import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class LockScrollService {
  private lockScrollCounter = 0;

  private valueSource = new Subject<boolean>();
  isScrollLocked = this.valueSource.asObservable();

  constructor() { }

  // setTimeout calls are to work-around the `changed after checked` error.

  requireScrollLock() {
    this.lockScrollCounter += 1;
    if (this.lockScrollCounter === 1) setTimeout(() => this.valueSource.next(true));
  }

  releaseScrollLock() {
    this.lockScrollCounter -= 1;
    if (this.lockScrollCounter < 0) {
      console.error('Unbalanced releaseScrollLock call detected');
      this.lockScrollCounter = 0;
    }
    if (this.lockScrollCounter === 0) setTimeout(() => this.valueSource.next(false));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/lock-scroll.service.ts